module.exports = __webpack_public_path__ + "img/highSpeedRail-5.b4a98bbe.jpg";